import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppMainComponent } from '../../../app.main.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccountUserService } from '../../../service/account.service';
import { TasksService } from '../../tasks';
import { categoryModuleId, categorychannelId, exportChannelId, exportModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AppMainService } from 'src/app/app-main.service';
import { TaskCategoryService } from 'src/app/shared/api/taskCategory.service';
import { ActivatedRoute } from '@angular/router';
import { Fields } from 'src/app/modules/shared/models/column-settings.model';
import { FilterInColumn, SavedFilterData } from 'src/app/accounts-v2/models/account-request.model';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { TimeZoneService } from 'src/app/modules/shared/services/timezone.service';
import { filterDateRangeHelper } from 'src/app/modules/shared/helpers/filter-date-range.helper';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit, OnDestroy {
  listColsAll: Fields[] = [];
   //Filter & GroupBy 
   saveFilterData: SavedFilterData;
   filterInColumns: FilterInColumn[];
   disabledLabelNames: string[] = [];
   savedListCols: Fields[] = [];
   savedListColsVM: Fields[] = [];
   appliedFilterColName: string[] = [];
   selectedGroupByValue: any;
   selectedGroupBy: any = null;


 
  constructor(
    private route: ActivatedRoute,
    public app: AppMainComponent,
    private messageService: MessageService,
    private accountUserService: AccountUserService,
    private tasksService: TasksService,
    private appMainService: AppMainService,
    private taskCategoryService: TaskCategoryService,
    private confirmationService: ConfirmationService,
    private accountServiceN: AccountServiceN,
    private timeZoneService: TimeZoneService,

  ) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.route.queryParams.subscribe(params => {
        const id = parseInt(params['id']||'0');
        if (id) {
          this.onSelectTask({id: id});
        }
    });
 }

  user:any;
  displayAddTask : boolean = false;
  menuItems = [];
  displaySetting : boolean = false;
  categoryModuleId : number = 0;
  categorychannelId :  number = 0;
  exportModuleId : number = 0;
  exportChannelId :  number = 0;
  columnSetting :any[]=[];
  cols :any[]=[];
  showSideBarIcon: boolean;
  @Input() isHideSide:boolean | undefined ;
  @Input() selectedWorkspace;
  @Input() selectedView;
  // @Output() onToggleSideBar: EventEmitter<any> = new EventEmitter();
  isAddTask: boolean = false;
  @Output() toggleSideBar: EventEmitter<any> = new EventEmitter();

  breadcrumbItems: any[];
  enabledListCols=[];
  searchValue: string;
  searchControl = new FormControl();
  private destroy$ = new Subject<void>();
  selectedFilterValue:string = 'AllTasks';

  

  ngOnInit(): void {
    this.showSideBarIcon = this.isHideSide === undefined
    this.getCollumnSetting();
    this.handleChange({index:0});
    // this.updateBreadcrumb();
    this.searchAccounts()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Fired when user start typing on search bar
  searchAccounts() {
    this.searchControl.valueChanges.pipe(
      takeUntil(this.destroy$),
      debounceTime(700),
      distinctUntilChanged()
    ).subscribe((value: string) => {
      this.searchValue = value?.trim() || '';
    });
  
}

  updateBreadcrumb(){
    this.breadcrumbItems = [
      {  icon: 'pi pi-home', command: () => {this.selectedView = "list"}, },
      { label: `${this.selectedWorkspace.name}`, icon: 'pi pi-folder-open' }
    ];
  }

  handleChange(e) {  
    switch (e.index) {
      case 0:
        this.app.filterMode = 'all';
        this.selectedFilterValue = 'AllTasks';
        break;
      case 1:
        this.app.filterMode = 'by-me';
        this.selectedFilterValue = 'ByMe';
        break;
      case 2:
        this.app.filterMode = 'for-me';
        this.selectedFilterValue = 'ForMe';
        break;
      case 3:
        this.app.filterMode = 'share-with-me';
        this.selectedFilterValue = 'SharedWithMe';
        break;
      case 4:
        this.app.filterMode = 'completed'
        this.selectedFilterValue = 'Completed';
        break;
      default:
        break;
    }
  }

  // Selecting a task from the task table
  onSelectTask(event) {
    this.app.selectedTaskId = event?.id;
    this.app.displayEditViewTask = true;
  }

  //tasks
  showAddTask() {
    this.displayAddTask = true;
    this.isAddTask = true;
  }

  cancelClicked(event) {
    this.displayAddTask = false;
    this.isAddTask = false;
  }

  reloadTaskiList() {
    this.displayAddTask = false;
    this.tasksService.createUpdateTask(this.app.filterMode);
  }

  openSetting(){
    this.displaySetting = true;
  }

  openExport(){
   this.confirmationService.confirm({
    message: "Do you want to Export Task Data?",
    header: "Export Confirmation",
    icon: "pi pi-info-circle",
    accept: () => {
      const selectableColumns: any[] = [];
      if (this.cols?.length > 0) {
        this.cols.forEach((obj) => {
          if (obj.enabled) {
            selectableColumns.push(
              {
                columnName: obj.columnName,
                isCustom: obj.isCustom,
                labelName: obj.name
              }
            )
          }
        });
      }
      const data = {
        channelId: exportChannelId,
        moduleId: exportModuleId,
        isActive: true,
        filter: this.selectedFilterValue,
        columns: selectableColumns,
        stageId: null
      }
      this.tasksService.postExport(data).subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner('Export');
          this.messageService.add({
            severity: 'success', summary: 'Succes',
            detail: "Export Successfully, Please Check My Documents..."
          });

        },
        error: (error) => {
          this.appMainService.isHideSpinner('Export');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });

        },
        complete: () => {
          this.appMainService.isHideSpinner('Export');
        }
      });
    },
    reject: () => { },
  });
  }

  cancelSetting(){
    this.displaySetting = false;
  }

  // toggleSideBar(){
  //   this.onToggleSideBar.emit();
  // }

  onToggleSideBar(){
    this.toggleSideBar.emit();
  }

  // #region Filter&GroupBy
  getCollumnSetting() {
    this.categoryModuleId = categoryModuleId;
    this.categorychannelId = categorychannelId
    this.appMainService.isShowSpinner('columnSetting');
    this.taskCategoryService.getColumnSetting(this.categoryModuleId, this.categorychannelId).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('columnSetting');
        this.cols = response.listViewSections[0].fields;
        this.listColsAll = JSON.parse(JSON.stringify(this.cols));
        this.getFilterData();

        this.listColsAll = this.listColsAll.filter(item => item.columnName !== 'completionStatus');
        this.savedListCols = this.listColsAll
        this.setGroupCols();

      },
      error: (error) => {
        this.appMainService.isHideSpinner('columnSetting');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.Message ?? 'something went wrong'
        });
      }
    })
  }

  getFilterData() {
    this.appMainService.isShowSpinner('getFilterData');
    let requestModel: { moduleId: number, channelId: number } = {
      moduleId: categoryModuleId,
      channelId: categorychannelId,
    }
    this.accountServiceN.getSavedFilterDataChannalWise(requestModel).subscribe({
      next: (data: SavedFilterData) => {
        if (data) {
          this.saveFilterData = data;
          this.filterInColumns = this.saveFilterData?.filter.map((data) => {
            let field: FilterInColumn = {
              name: data.columnName,
              operator: data?.operator,
              operationType: data?.operationType,
              isCustom: data?.isCustom,
              fieldId: data?.fieldId,
            }
            if (data.operator == "On" || data.operator == "NotOn") {
              field.values = [];
              field = this.dateOnOperatorListValue(data, field);
            } else {
              field.values = data?.values;
            }
            return field;
          });
          if (this.savedListCols?.length > 0) {
            this.enabledListCols = this.savedListCols.filter(field => field.enabled);
            this.enabledListCols = this.enabledListCols.filter(item => item.columnName !== 'id');
            this.selectedGroupBy = this.enabledListCols.find((item) => {
              return item?.id == this.saveFilterData?.groupByFieldId;
            });
            this.selectedGroupBy = this.enabledListCols.find((item) => {
              return item?.id == this.saveFilterData?.groupByFieldId;
            });
          }
          this.selectedGroupByValue = this.selectedGroupBy;
          if (this.selectedGroupBy) {
            this.disabledLabelNames = [...new Set([...this.appliedFilterColName, this.selectedGroupBy.columnName])];
          } else {
            this.disabledLabelNames = [];
          }
        } else {
          this.saveFilterData = null;
          this.filterInColumns = null;
          this.selectedGroupByValue = null;
          this.selectedGroupBy = null;
          this.disabledLabelNames = [];
        }
        //this.filterInColumns =null ;
        //this.handleChange({index:0});
        this.appMainService.isHideSpinner('getFilterData');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when getting filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('getFilterData');
      },
    })
  }

  applyFilters(event: { selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[] }, reloadList: boolean = true) {
    this.filterInColumns = event?.selectedFilter || null;
    if (event?.selectedFilter?.length > 0) {
      let saveFilterData: SavedFilterData = {};
      saveFilterData = {
        groupByFieldId: this.selectedGroupByValue?.id ? this.selectedGroupByValue?.id : null,
        filter: event?.selectedColumnsForSaveFilterFieldsChannelWise?.length > 0 ? event?.selectedColumnsForSaveFilterFieldsChannelWise : null,
      }
      this.saveFilterDataChannalWise(saveFilterData);
    } else {
      this.resetSavedFilterChannelWise();
    }
  }

  resetFilters(reloadList: boolean = false) {
    this.applyFilters({ selectedFilter: null, selectedColumnsForSaveFilterFieldsChannelWise: null }, reloadList);
  }

  resetSavedFilterChannelWise() {
    this.appMainService.isShowSpinner('resetSavedFilterChannelWise');
    let requestBody: {
      moduleId: number,
      channelId: number,
    } = {
      moduleId: categoryModuleId,
      channelId: categorychannelId,
    }
    this.accountServiceN.resetSavedFilterChannelWise(requestBody).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('resetSavedFilterChannelWise');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when reset filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('resetSavedFilterChannelWise');
      }
    });
  }


  saveFilterDataChannalWise(selectedColumns: SavedFilterData) {
    this.appMainService.isShowSpinner('saveFilterDataChannalWise');
    let requestBody: {
      moduleId: number,
      channelId: number,
      filterData: SavedFilterData
    } = {
      moduleId: categoryModuleId,
      channelId: categorychannelId,
      filterData: selectedColumns,
    }

    this.accountServiceN.saveFilterDataChannalWise(requestBody).subscribe({
      next: (response) => {
        // this.saveFilterData = response;
        this.appMainService.isHideSpinner('saveFilterDataChannalWise');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when saving filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('saveFilterDataChannalWise');
      }
    });
  }

  //#region GroupBy
  setGroupCols() {
    this.enabledListCols = this.savedListCols.filter(field => field.enabled);
    this.enabledListCols.map(field => {
      field.groupByColumnName = field.columnName;

    });

    const checkExist = this.enabledListCols.find(field => field.columnName == this.selectedGroupByValue?.columnName);
    if (this.selectedGroupByValue && !checkExist) {
      this.selectedGroupByValue = null;
    }
  }

  applyGroup() {
    if (this.selectedGroupBy) {
      this.disabledLabelNames = [...new Set([...this.appliedFilterColName, this.selectedGroupBy.columnName])];
    }

    this.selectedGroupByValue = this.selectedGroupBy;
    let saveFilterData: SavedFilterData = {};
    saveFilterData = {
      groupByFieldId: this.selectedGroupByValue?.id ? this.selectedGroupByValue?.id : null,
      filter: this.filterInColumns?.length > 0 ? this.filterInColumns : null,
    }
    this.saveFilterDataChannalWise(saveFilterData);
  }

  resetSavedGroupByChannelWise() {
    this.appMainService.isShowSpinner('resetSavedGroupByChannelWise');
    let requestBody: {
      moduleId: number,
      channelId: number,
    } = {
      moduleId: categoryModuleId,
      channelId: categorychannelId,
    }
    this.accountServiceN.resetSavedGroupByChannelWise(requestBody).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('resetSavedGroupByChannelWise');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when reset filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('resetSavedGroupByChannelWise');
      }
    });
  }

  resetGroup(reloadList: boolean = false) {
    this.disabledLabelNames = this.disabledLabelNames.filter(dln => dln !== (this.selectedGroupByValue?.columnName ?? ''));
    this.disabledLabelNames = [...new Set([...this.disabledLabelNames, ...this.appliedFilterColName])]
    this.selectedGroupBy = null;
    this.selectedGroupByValue = null;
    this.resetSavedGroupByChannelWise();
  }

  //#endregion GroupBy


  public dateOnOperatorListValue(data: {
    columnName?: string;
    value?: string;
    operator: string;
    operationType?: string;
    values?: string[];
    isCustom?: boolean;
    fieldId?: number;
  }, field: FilterInColumn) {

    const dateRange = filterDateRangeHelper(data?.values[0]);
    let dateRangeFrom: Date | null = dateRange?.dateRangeFrom;
    let dateRangeTo: Date | null = dateRange.dateRangeTo;

    if ((dateRangeFrom && dateRangeTo)) {
      const fieldDetails = this.savedListColsVM.find(fld => fld?.columnName == data?.columnName);
      field.operator = data.operator == 'NotOn' ? 'NotBetween' : 'Between';
      dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (fieldDetails?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(data?.values[0]));
      dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (fieldDetails?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(data?.values[0]));
      dateRangeTo.setDate(dateRangeTo.getDate() + 1);
      dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
      field.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo));
    } else if (data.values?.[0]) {
      field.operator = data.operator == 'NotOn' ? 'NotBetween' : 'Between';
      field.values.push(data.values?.[0], data.values?.[0])
    }

    return field;
  }


  columnsettting(columnSettings: any) {
    if (columnSettings?.listViewSections?.length) {
      this.cols = columnSettings.listViewSections[0].fields;
      this.getCollumnSetting();
    }
  }

  savedColumnSettings(): void {
    this.displaySetting = false;
    this.getCollumnSetting();
  }

  refreshList() {
    this.tasksService.setTaskRefreshList(true);
    if(this.searchControl.value){
      this.searchControl.reset()
    }
  }

}
